import { Injectable } from '@angular/core';

import { Subject } from 'rxjs';

import { ColumnState } from 'ag-grid-community';

import { TableRendererActionEvent, TablesColumnState } from '@models/table';
import { IconRendererParams } from '@models/renderer-parameters';
import { Company } from '@models/company';
import { Payment } from '@models/payment';
import {
  CompanyStatementReport,
  JobsByCompanyReport,
  SalesByMarketerReport,
  UserStatementReport
} from '@models/report';

@Injectable({
  providedIn: 'root'
})
export class TableService {
  public rendererAction$: Subject<TableRendererActionEvent<unknown>> = new Subject<TableRendererActionEvent<unknown>>();

  public getTableColumnState(id: string): Array<ColumnState> | null {
    const tablesColumnState: TablesColumnState = this.getTablesColumnState();
    return tablesColumnState[id] || null;
  }

  public setTableColumnState(id: string, state: Array<ColumnState>): void {
    const tablesColumnState: TablesColumnState = this.getTablesColumnState();

    tablesColumnState[id] = state;

    this.setTablesColumnState(tablesColumnState);
  }

  public removeTablesColumnState(): void {
    localStorage.removeItem('tablesColumnState');
  }

  public canResetTableColumns(): boolean {
    const tablesColumnState: TablesColumnState = this.getTablesColumnState();
    return Object.keys(tablesColumnState).length > 0;
  }

  public getIconRendererParams(
    entity: Company | Payment | JobsByCompanyReport | SalesByMarketerReport | CompanyStatementReport | UserStatementReport
  ): Array<IconRendererParams> {
    const res: Array<IconRendererParams> = [];

    if (entity.company_from_qualia) {
      res.push({
        icon: 'qualia',
        isSvgIcon: true,
        tooltip: 'Qualia Company'
      });
    }

    if (entity.company_has_custom_pricing) {
      res.push({
        icon: 'attach_money',
        isSvgIcon: false,
        tooltip: 'Custom Pricing'
      });
    }

    return res;
  }

  private getTablesColumnState(): TablesColumnState {
    return JSON.parse(localStorage.getItem('tablesColumnState') || '{}');
  }

  private setTablesColumnState(state: TablesColumnState): void {
    localStorage.setItem('tablesColumnState', JSON.stringify(state));
  }
}
